import React from 'react';

function Logo(props) {
  return (
    <img
      alt="HDI Seguros"
      src="/static/hdi_logo.png"
      style={{ maxHeight: 150, maxWidth: '95%' }}
      {...props}
    />
  );
}

export default Logo;
